import React from "react";

const LogoMarkGreyscale = () => {
  return (
    <svg
      className="txt-logo-mark-greyscale"
      width="79"
      height="76"
      viewBox="0 0 79 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.6614 75.8186H20.3828C25.8065 66.0443 24.5461 68.4547 35.9583 47.8806C44.6342 50.8611 48.1688 51.8226 50.909 50.14C47.174 56.8428 41.7898 66.6259 36.6614 75.8186Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M62.4471 2.19537e-05L78.5988 2.21349e-05C73.2015 10.0235 69.0552 17.4337 58.3601 36.6796C57.1102 30.5263 52.6875 28.0745 46.9668 28.0745C50.8542 21.0535 57.0654 9.72628 62.4471 2.19537e-05Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M49.0852 47.3046C43.4869 48.5866 37.7914 42.0011 5.57617 39.2555C37.9694 36.6616 42.9529 29.7202 49.0852 31.4238C57.8741 33.8655 57.3336 45.4158 49.0852 47.3046Z"
        fill="url(#paint2_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="31.6257"
          y1="-4.13548"
          x2="31.6257"
          y2="75.8617"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.734282" stopColor="#D5D5D5" />
          <stop offset="1" stopColor="#E7E7E7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="68.8697"
          y1="1.56059e-06"
          x2="25.1759"
          y2="79.6296"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.58149" stopColor="#D5D5D5" />
          <stop offset="1" stopColor="#F0F0F0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="13.8928"
          y1="21.2"
          x2="54.8989"
          y2="43.7462"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.453422" stopColor="#E7E7E7" />
          <stop offset="0.958162" stopColor="#D3D3D3" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LogoMarkGreyscale;
